import { Component, OnInit, EventEmitter, Output, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { FacetValueModel } from 'src/app/models/facet-value-model';
import { DateFacetService } from 'src/app/services/date-facet.service';
import { DateSelectionService } from 'src/app/services/date-selection.service';

@Component({
  selector: 'app-results-facet-date',
  templateUrl: './results-facet-date.component.html',
  styleUrls: ['./results-facet-date.component.css']
})
export class ResultsFacetDateComponent implements OnInit, OnChanges {

  @Input() facetDetails?: FacetValueModel[] = [];
  @Input() facetName: string = '';
  @Input() selectedItems: TreeNode[] = [];
  @Output() onSelected = new EventEmitter();
  @Output() onRemoved = new EventEmitter();

  items: TreeNode[] = [];

  constructor(private dfSvc: DateFacetService, private dateSelectionSvc: DateSelectionService) {
  }

  ngOnInit(): void {
    this.items = this.dfSvc.parseFacetToTree(this.facetName, this.facetDetails);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['facetDetails']) {
      this.facetDetails = changes['facetDetails'].currentValue as FacetValueModel[];
      this.items = this.dfSvc.parseFacetToTree(this.facetName, this.facetDetails);
    }
  }

  itemSelected(item: any) {
    let selectedNode: TreeNode = item.node;

    // console.log('date Node: ' + JSON.stringify(item));
    this.onSelected.emit(selectedNode.data);
  }

  itemUnSelected(item: any) {
    let node = item.node;

    this.onRemoved.emit(node.data);
  }
}
